
import { Box, Typography } from '@mui/material'

import DoneAllIcon from "@mui/icons-material/DoneAll";

interface Props {
    message:                string;
    messageAssing?:         string;
    processEnd?:            boolean;
}

export const BoxProcesoTerminado = ( { message, messageAssing, processEnd }: Props ) => {

    return (
       <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight={580}
        >
            <Box sx={{ maxWidth: 600, width: '90%', textAlign: 'center', p: 4, borderRadius: 4 }}>
               
                <Box sx={{ mb: 1 }} >
                    <DoneAllIcon sx={{ fontSize: 180 }} />
                </Box>

                <Box>

                    <Typography variant="h4" fontWeight="bold" gutterBottom>
                        { processEnd ? 'Proceso finalizado' : 'Actividad finalizada' }
                    </Typography>

                    {
                        message
                        &&
                            <Typography variant="body2" color="text.secondary" fontSize={16} gutterBottom>
                               { message }
                            </Typography>
                    }

                    {
                        messageAssing
                        &&
                            <Typography variant="body2" color="text.secondary" fontSize={16} sx={{ my: 3 }}>
                                { messageAssing }
                            </Typography>
                    }

                </Box>

            </Box>

        </Box>
    )
}